import React from 'react';
import { Field } from 'react-final-form';
import { Box } from 'src/kit';
import { StyledInput, StyledInputProps, ValideIcon, StyledError } from 'src/kit/StyledInput';

const hasError = meta => meta.touched && meta.error;
const hasSubmitError = meta => meta.touched && !meta.dirtySinceLastSubmit && meta.submitError;

export type InputProps = StyledInputProps & {
  name: string;
  validate?: any;
  isValidated?: boolean;
  mb?: any;
};

const Input = ({ name, validate, isValidated, mb, ...rest }: InputProps) => (
  <Field name={name} validate={validate}>
    {({ input, meta }) => (
      <Box position="relative" mb={mb}>
        <StyledInput
          {...input}
          {...rest}
          error={hasError(meta) || hasSubmitError(meta)}
          valid={meta.touched && !meta.error && !meta.submitError}
        />
        {isValidated && meta.touched && !hasError(meta) && <ValideIcon size={16} />}
        {hasError(meta) && <StyledError>{meta.error}</StyledError>}
        {hasSubmitError(meta) && <StyledError>{meta.submitError}</StyledError>}
      </Box>
    )}
  </Field>
);

Input.defaultProps = {
  isValidated: true,
  mb: 10
};

export default Input;
